import { FC } from "react";
import { Props } from "./types";
import IconSearch from "../../../Static/Icons/search_white.png";
export const Search: FC<Props> = ({ className, ...props }): JSX.Element => {
  return (
    <img className={className} src={IconSearch} alt="search_white" {...props} />
  );
};
